// The print view: the story as a mini-book page, shown only when printing
// (compose.css § Print). Unresolved words, and words whose spelling nothing
// vouches for, print as blanks a grown-up can fill in by hand; the child's
// voice is never on paper, and neither is the ASR's guess.
import { type CompositionToken, sentences } from "@bindery/composition";
import { storyPieces } from "./ladder";

export function PrintBook({
  tokens,
  blanks,
  title,
  printedOn,
}: {
  tokens: readonly CompositionToken[];
  /** Words printed as blanks, as unresolved slots are. */
  blanks: ReadonlySet<string>;
  title: string;
  printedOn: string;
}) {
  const byId = new Map(tokens.map((t) => [t.id, t] as const));
  return (
    <section className="compose-print" aria-hidden>
      <h1>{title}</h1>
      {sentences(tokens).map((ids, i) => {
        const sentence = ids.flatMap((id) => {
          const token = byId.get(id);
          return token === undefined ? [] : [token];
        });
        return (
          <p key={ids[0] ?? i}>
            {storyPieces(sentence, blanks).map((piece, j) =>
              piece.kind === "blank" ? (
                <span key={j} className="compose-print-blank" />
              ) : (
                piece.text
              ),
            )}
          </p>
        );
      })}
      <footer>Told aloud and printed {printedOn}.</footer>
    </section>
  );
}
